module.exports = __webpack_public_path__ + "static/media/map-black.1b6ac950.svg";